import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface Kpi {
  rotulo: ReactNode;
  valor: ReactNode;
  apoio?: ReactNode;
  /** "destaque" = laranja (ex.: líquido a pagar); "negativo" = vermelho; "alerta" = âmbar. */
  tom?: "destaque" | "negativo" | "alerta";
}

/**
 * Faixa de KPIs: um card só, dividido em células com borda entre elas.
 * `embutida` tira a borda/raio próprios para usar no rodapé de outro card.
 */
export const FaixaKpis = ({
  itens,
  embutida = false,
  minimo = 150,
  className,
}: {
  itens: Kpi[];
  embutida?: boolean;
  /** Largura mínima de cada célula, em px. */
  minimo?: number;
  className?: string;
}) => (
  <div
    className={cn(
      "grid overflow-hidden tabular-nums",
      embutida ? "border-t" : "rounded-xl border bg-card",
      className,
    )}
    style={{ gridTemplateColumns: `repeat(auto-fit, minmax(${minimo}px, 1fr))` }}
  >
    {itens.map((k, i) => (
      <div
        key={i}
        className={cn(
          // A borda à direita + a de baixo (com -mb/-mr) desenham a grade em qualquer quebra de linha.
          "-mb-px -mr-px flex flex-col gap-0.5 border-b border-r border-border-soft px-5 py-4 sm:px-6",
          k.tom === "destaque" && "bg-primary/5",
        )}
      >
        <span className="text-xs text-muted-foreground">{k.rotulo}</span>
        <span
          className={cn(
            "text-lg font-semibold",
            k.tom === "destaque" && "text-primary",
            k.tom === "negativo" && "text-destructive",
            k.tom === "alerta" && "text-amber-700 dark:text-amber-400",
          )}
        >
          {k.valor}
        </span>
        {k.apoio && <span className="text-xs text-muted-foreground">{k.apoio}</span>}
      </div>
    ))}
  </div>
);
